import { Capacitor } from '@capacitor/core';

let revenueCatInitialized = false;

function resolveApiKey(): string | undefined {
  const platform = Capacitor.getPlatform();
  const iosKey = import.meta.env.VITE_REVENUECAT_IOS_API_KEY?.trim();
  const androidKey = import.meta.env.VITE_REVENUECAT_ANDROID_API_KEY?.trim();
  const fallbackKey = import.meta.env.VITE_REVENUECAT_API_KEY?.trim();

  // RevenueCat Test Store: only for debug builds (the SDK closes a release
  // build that carries a test_ key), so it has to be opted into explicitly.
  const testStoreKey = import.meta.env.VITE_REVENUECAT_TEST_STORE_API_KEY?.trim();
  if (import.meta.env.VITE_REVENUECAT_USE_TEST_STORE === 'true' && testStoreKey) {
    return testStoreKey;
  }

  if (platform === 'ios') {
    return iosKey || fallbackKey;
  }
  if (platform === 'android') {
    return androidKey || fallbackKey;
  }
  return undefined;
}

/**
 * Configures RevenueCat on Capacitor native shells only. No-op on web.
 */
export async function initializeRevenueCat(): Promise<void> {
  if (!Capacitor.isNativePlatform()) return;
  if (revenueCatInitialized) return;

  const apiKey = resolveApiKey();
  if (!apiKey) {
    console.warn(
      '[RevenueCat] Missing API key. Set VITE_REVENUECAT_API_KEY or VITE_REVENUECAT_IOS_API_KEY / VITE_REVENUECAT_ANDROID_API_KEY.',
    );
    return;
  }

  try {
    const { Purchases, LOG_LEVEL } = await import('@revenuecat/purchases-capacitor');
    if (import.meta.env.DEV) {
      await Purchases.setLogLevel({ level: LOG_LEVEL.DEBUG });
    }
    await Purchases.configure({ apiKey });
    revenueCatInitialized = true;
  } catch (err) {
    console.error('[RevenueCat] Configuration failed:', err);
  }
}
